export const planQueryKeys = {
  GET_PLANS: 'getPlans',
  ARCHIVE_URL: 'archiveUrl',
  INDICES: 'indices',
  GET_PLAN_DETAILS: 'getPlanDetails',
  GET_PLAN_FOLDER_DETAILS: 'getPlanFolderDetails'
}

export const planMutationKeys = {
  UPDATE_PLAN_DETAILS: 'updatePlanDetails',
  UPDATE_PLAN_FOLDER_DETAILS: 'updatePlanFolderDetails',
  CREATE_PLAN_FOLDER: 'createPlanFolder',
  MOVE_PLANS_AND_FOLDERS: 'movePlansAndFolders',
  CHECK_CHILDREN_NAME_IS_AVAILABLE: 'checkChildrenNameIsAvailable'
}

export const plansApiTypeOptions = {
  PROJECTS: 'projects',
  FOLDERS: 'folders'
}

export const planTreeTypeFilterOptions = {
  ALL: 'All',
  FOLDERS: 'Folders',
  PLANS: 'Plans'
}
